module.exports = __webpack_public_path__ + "static/img/noorder@2x.05b7d21.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/noorder@2x.png
// module id = Q8zR
// module chunks = 12